import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import * as authActions from '../../Redux/Auth/AuthActions';
import Layout from "../../Utils/Navbar/navbar-layout-component";
import { getComingSoonData } from "../../Public/coming-soon-data";
import { ButtonPrimary } from "../../Utils/Buttons/button-component";
import Image from "../../Utils/Image/image-component";

function ComingSoon() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    // 1. System Context & Localization
    const { language = 'en', dir } = useSelector((state) => state.systemData || {});
    const txt = getComingSoonData(language);

    const handleRedirect = (e) => {
        e.preventDefault();
        const path = '/';
        dispatch(authActions.redirectScreen(path));
        navigate(path);
    };

    /**
     * Splits by ':' to apply the branded orange highlight
     * Example: COMING (Primary) SOON (Orange)
     */
    const renderTitle = (text) => {
        if (!text) return null;
        const parts = text.split(':');
        return (
            <>
                {parts[0]} <span className="text-secondary-500">{parts[1]}</span>
            </>
        );
    };

    return (
        <Layout seo={txt.seo}>
            <div dir={dir} className="min-h-screen w-full bg-white font-assistant flex flex-col items-center justify-center relative overflow-hidden">
                
                {/* Visual Blueprint Grid Pattern */}
                <div className="absolute inset-0 opacity-[0.03] pointer-events-none bg-[radial-gradient(#003366_1px,transparent_1px)] [background-size:40px_40px]"></div>

                <main className="relative z-10 w-full max-w-7xl px-6 py-20 flex flex-col items-center text-center">
                    
                    {/* Branded Header */}
                    <h1 className="text-6xl md:text-8xl lg:text-[10rem] font-black text-primary-900 leading-none uppercase er mb-12">
                        {renderTitle(txt.title)}
                    </h1>

                    {/* Mascot / Brand Asset */}
                    <div className="w-full max-w-sm mb-12 animate-float">
                        <Image 
                            src={txt.image} 
                            alt="Maintenance Mascot" 
                            className="w-full h-auto object-contain"
                            useSekeleton={false}
                        />
                    </div>

                    {/* Content Section */}
                    <div className="max-w-2xl space-y-6">
                        <h2 className="text-3xl md:text-5xl font-black text-slate-900 uppercase ">
                            {txt.subtitle}
                        </h2>
                        <p className="text-xl md:text-2xl text-slate-500 font-medium italic leading-relaxed">
                            {txt.description}
                        </p>
                        
                        <div className="pt-10 flex justify-center">
                            <ButtonPrimary 
                                onClick={handleRedirect}
                                size="lg"
                                className="!rounded-full px-16 py-6 text-xl uppercase font-black tracking-widest shadow-2xl shadow-blue-500/20"
                            >
                                {txt.buttonText}
                            </ButtonPrimary>
                        </div>
                    </div>
                </main>
            </div>
        </Layout>
    );
}

export default ComingSoon;